var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-table',{ref:"table",attrs:{"url":"/api/v1/agency","attributes":[
      {
        attribute: 'name',
        name: 'Name'
      },
      {
        name: 'Moderatoren',
        attribute: 'moderatorsCount',
        type: 'StaticText'
      },
      {
        name: 'Bearbeiten',
        type: 'EditAgencyNameModalCell',
        sortable: false
      }
    ]}}),_vm._v(" "),_c('resource',{attrs:{"resource":"agency","resourceName":"Agentur","attributes":[
      {
        name: 'name',
        label: 'Name'
      }
    ]},on:{"persisted":function($event){return _vm.refreshTable()}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Agentur erstellen")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }